import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { GTM_ID } from '../../../../common/constants/gtmIds';

const FilterBox = ({
  handleInteraction,
  children,
  width,
  isClickable,
  gtmId = GTM_ID.FILTER_SELECT,
  className,
}) => {
  return (
    <div
      onClick={handleInteraction}
      onKeyDown={handleInteraction}
      className={className}
      role="searchbox"
      tabIndex={0}
      data-gtm-id={gtmId}
      data-testid="filter-select"
    >
      {children}
    </div>
  );
};

// === FilterBox CSS ===
const StyledFilterBox = styled(FilterBox)`
  --default-width: 24rem;

  display: flex;
  align-items: center;
  background-color: ${vars.white};
  height: 3.5rem;
  width: ${({ width }) => (width ? width : 'var(--default-width)')};
  min-width: fit-content;
  border: 1px solid ${vars.borderGrey};
  ${vars.fontSize2}
  font-weight: ${vars.fontWeightRegular};
  padding: ${vars.spacingS};

  ${({ isClickable }) => (isClickable ? 'cursor: pointer' : null)}
`;

export default StyledFilterBox;
